import { StyledBoard } from "./styled";
import { IBoardProps } from "./types";

const Board = ({children, ...props}: IBoardProps)=>(
    <StyledBoard {...props}>
        {children}
    </StyledBoard>
)

export {Board}